import TrendChart from './TrendChart';

export default TrendChart;

export type { ITrendChartProps, ITrendSeries, TrendChartVariant } from './TrendChart';
